import Background from "./Background";
import "./SharedBook.css";
import { firestore } from "../firebase/firebaseConfig";
import BookBackground from "../assets/book_background.webp";
import { useEffect, useState } from "react";
import HTMLFlipBook from "react-pageflip";
import { useIsMobile } from "../hooks/useIsMobile";
import {
  MedievalBackground,
  MedievalIntroduction,
} from "../scenarios/MedievalScenario";
import languages from "../assets/languages.json";
import { useLocation } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { ReactComponent as Heart } from "../assets/Heart.svg";
import { doc, getDoc } from "firebase/firestore";

function SharedBook() {
  const [currentBook, setCurrentBook] = useState(null);
  const [bookCover, setBookCover] = useState(null);
  const [scenarioIntroduction, setScenarioIntroduction] = useState("");
  const location = useLocation();
  const isMobile = useIsMobile();

  const queryParams = new URLSearchParams(location.search);
  const bookId = queryParams.get("id");

  useEffect(() => {
    const bookRef = doc(firestore, "books", bookId);

    getDoc(bookRef).then((docSnapshot) => {
      const data = docSnapshot.data();

      if (!data) return;

      const book = {
        id: docSnapshot.id,
        author: data["author"],
        title: data["title"],
        content: data["book"],
        scenario: data["scenario"],
        likes: data["likes"],
        languageIndex: data["languageIndex"],
      };

      setCurrentBook(book);
    });
  }, []);

  useEffect(() => {
    if (currentBook) {
      switch (currentBook.scenario) {
        case "Medieval":
          setBookCover(MedievalBackground());
          setScenarioIntroduction(
            MedievalIntroduction(
              languages.languages[currentBook.languageIndex].short
            )
          );
          break;
        default:
          break;
      }
    }
  }, [currentBook]);

  return (
    <>
      <Background></Background>
      <div className="shared-book">
        {currentBook ? (
          <>
            <div className="book-opened-darken"></div>
            <div className="book-table">
              <HTMLFlipBook
                width={isMobile ? 300 : window.innerHeight <= 850 ? 500 : 700}
                height={isMobile ? 400 : window.innerHeight <= 850 ? 600 : 800}
                className="book"
                showCover={true}
              >
                <div>
                  <div
                    style={{
                      position: "absolute",
                      backgroundImage: `url(${bookCover})`,
                      height: "100%",
                      width: "100%",
                      position: "absolute",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      boxShadow: "inset 15px 0px 20px 3px black",
                    }}
                  >
                    <p
                      style={{
                        marginTop: "100px",
                        textAlign: "center",
                        fontSize: "26px",
                        color: "white",
                        textShadow: "0px 0px 5px black",
                        textDecoration: "underline",
                      }}
                    >
                      {currentBook.author}
                    </p>
                    <p
                      style={{
                        marginTop: isMobile ? "50px" : "150px",
                        textAlign: "center",
                        fontSize: isMobile ? "40px" : "50px",
                        width: "80%",
                        color: "white",
                        textShadow: "0px 0px 5px black",
                        wordBreak: "break-word",
                        fontWeight: "bold",
                      }}
                    >
                      {currentBook.title}
                    </p>
                  </div>
                </div>
                {currentBook.content.map((content, index) => (
                  <div key={index}>
                    <div
                      style={{
                        backgroundImage: `url(${BookBackground})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        fontSize: isMobile
                          ? "12px"
                          : window.innerHeight <= 850
                          ? "14px"
                          : "20px",
                        fontFamily: "'Garamond', serif",
                        color: "#704214",
                        textShadow: "1px 1px 1px rgba(0, 0, 0, 0.3)",
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "center",
                        border: "2px solid black",
                        boxShadow: "0px 0px 25px 5px black",
                        userSelect: "none",
                        transform: index % 2 !== 0 && "scaleX(-1)",
                        borderRadius: "10px",
                        zIndex: "99",
                      }}
                    >
                      <p
                        style={{
                          transform: index % 2 !== 0 && "scaleX(-1)",
                          width: isMobile
                            ? "200px"
                            : window.innerHeight <= 850
                            ? "340px"
                            : "470px",
                          height: isMobile
                            ? "260px"
                            : window.innerHeight <= 850
                            ? "450px"
                            : "550px",
                          overflow: "scroll",
                          padding: "0px 10px 0px 15px",
                          marginTop: isMobile ? "15px" : "80px",
                          lineHeight: isMobile
                            ? "16px"
                            : window.innerHeight <= 850
                            ? "21px"
                            : "24px",
                        }}
                      >
                        {content}
                      </p>
                      <p
                        style={{
                          transform: index % 2 !== 0 && "scaleX(-1)",
                          position: "absolute",
                          bottom: isMobile ? 10 : 40,
                          textAlign: "center",
                          width: "80%",
                          fontSize: "20px",
                        }}
                      >
                        {index + 1}
                      </p>
                    </div>
                  </div>
                ))}
                {currentBook.content.length % 2 !== 0 ? (
                  <div>
                    <div
                      style={{
                        backgroundImage: `url(${BookBackground})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        fontSize: "18px",
                        color: "white",
                        border: "2px solid black",
                        boxShadow: "0px 0px 25px 5px black",
                        userSelect: "none",
                        transform: "scaleX(-1)",
                      }}
                    >
                      <p
                        style={{
                          transform: "scaleX(-1)",
                          position: "absolute",
                          bottom: 0,
                          left: 50,
                        }}
                      >
                        {currentBook.content.length + 1}
                      </p>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                <div>
                  <div
                    style={{
                      backgroundImage: `url(${bookCover})`,
                      height: "100%",
                      width: "100%",
                      position: "absolute",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      boxShadow: "inset -15px 0px 20px 3px black",
                    }}
                  >
                    <p
                      style={{
                        width: "60%",
                        fontSize: isMobile ? "12px" : "20px",
                        color: "white",
                        textShadow: "0px 0px 5px black",
                      }}
                    >
                      {scenarioIntroduction}
                    </p>
                  </div>
                </div>
              </HTMLFlipBook>
            </div>

            <div className="book-actions">
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: "white",
                    userSelect: "none",
                    textShadow: "0px 0px 5px purple",
                  }}
                >
                  {currentBook.likes}
                </span>
                <Heart
                  className="button"
                  style={{
                    color: "rgba(255,255,255,1)",
                    height: "70px",
                  }}
                ></Heart>
              </div>
            </div>
          </>
        ) : (
          <Logo
            style={{
              width: "10%",
              height: "5%",
              filter: "drop-shadow(0px 0px 10px black)",
              color: "white",
              animation: "rotate 2s linear infinite",
            }}
          ></Logo>
        )}
      </div>
    </>
  );
}

export default SharedBook;
